<template>
	<div>
		<page-title-bar title="BẢNG ĐĂNG KÝ LẮP MẠNG"></page-title-bar>
		<v-container grid-list-xl pt-0>
            <page-tool-bar
                show_search
                show_building
                :chosen_building.sync="chosen_building"
                :search.sync="search"
            >
                <v-flex xs12 md2>
                    <v-select
                        v-model="filterRegistrationStatus"
                        :items="registrationStatusOptions"
                        label="Lọc theo trạng thái"
                        hide-details
                        prepend-icon="filter_list"
                    ></v-select>
                </v-flex>
                <v-flex shrink>
                    <div class="text-right">
                        <register-internet @reloadTable="reload_table++"></register-internet>
                        <v-btn @click="exportCSV++" color="primary" dark>XUẤT EXCEL</v-btn>
                    </div>
                </v-flex>
            </page-tool-bar>
            <v-layout row wrap justify-center>
                <v-flex xs12>
                    <v-card>
                        <internet-registration-table :chosen_building="chosen_building" :search="search" :reload_table="reload_table" :exportCSV="exportCSV" :filterRegistrationStatus="filterRegistrationStatus"></internet-registration-table>
                    </v-card>
                </v-flex>
            </v-layout>
		</v-container>
	</div>
</template>

<script>
import RegisterInternet from './RegisterInternet';
import { INTERNET_REGISTRATION_STATUS_LABEL_DISPLAYING_VALUES, INTERNET_REGISTRATION_STATUS_LABEL_DISPLAYING } from 'Constants/db-config';
import InternetRegistrationTable from './InternetRegistrationTable';

export default {
    name: 'internet-registration',
    components: {
        RegisterInternet,
        InternetRegistrationTable
    },
    data() {
        return {
            search:'',
            reload_table: 0,
            chosen_building: '',
            exportCSV: 0,
            filterRegistrationStatus: null,
            registrationStatusOptions: [
                { text: 'Tất cả', value: null },
                ...INTERNET_REGISTRATION_STATUS_LABEL_DISPLAYING_VALUES.map(status => ({
                    text: status,
                    value: status
                }))
            ]
        };
	},
    mounted(){
        this.reload_table++
    },
};
</script> 